// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JK6HT","content":"styles_content__oQT8F"};